import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
  const nodeSelectors = {
    container: '[js-slider="container"]',
    slider: '[js-slider="slider"]',
    prev: '[js-slider="prev"]',
    next: '[js-slider="next"]',
  };

  function init() {
    const containers = document.querySelectorAll(nodeSelectors.container);
    if (!containers.length) return;

    containers.forEach((container) => initSlider(container));
  }

  function initSlider(container) {
    const sliderEl = container.querySelector(nodeSelectors.slider);
    if (!sliderEl) return;

    // Ensure any videos have the right attributes for autoplay policies
    prepareVideos(sliderEl);

    const slider = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      speed: 500,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination') || '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: container.querySelector(nodeSelectors.next),
        prevEl: container.querySelector(nodeSelectors.prev),
      },

      on: {
        init(swiper) {
          syncVideos(swiper);
        },
        slideChangeTransitionStart(swiper) {
          // Stop videos as soon as slide starts changing
          stopAllVideos(swiper);
        },
        slideChangeTransitionEnd(swiper) {
          // Play video after the active slide is settled
          syncVideos(swiper);
        },
        // Helps when loop mode duplicates slides
        loopFix(swiper) {
          syncVideos(swiper);
        },
      },
    });

    return slider;
  }

  function prepareVideos(rootEl) {
    const videos = rootEl.querySelectorAll('video');
    videos.forEach((video) => {
      video.muted = true; // required for autoplay in most browsers
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.playsInline = true;
      video.preload = video.preload || 'metadata';

      // Optional: prevent the browser from trying to auto-play all videos
      video.autoplay = false;
      video.removeAttribute('autoplay');
    });
  }

  function getAllVideos(swiper) {
    // swiper.slides includes duplicated slides in loop mode (good for hard-stopping all)
    return swiper.el.querySelectorAll('video');
  }

  function stopAllVideos(swiper) {
    const videos = getAllVideos(swiper);
    videos.forEach((video) => {
      try {
        video.pause();
        // Reset so it starts from beginning next time it becomes active
        video.currentTime = 0;
      } catch (e) {
        // ignore
      }
    });
  }

  function loadAndPlayVideo(video) {
    const source = video.querySelector('source');

    if (source && !source.src) {
        source.src = source.dataset.src;
        video.load();
    }

    const playPromise = video.play();
    if (playPromise && playPromise.catch) {
        playPromise.catch(() => {});
    }
    }

    function syncVideos(swiper) {
        stopAllVideos(swiper);

        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        const activeVideo = activeSlide.querySelector('video');
        if (!activeVideo) return;

        loadAndPlayVideo(activeVideo);
    }

  return Object.freeze({ init });
};
